<template>
    <div v-show="show" id="transition-overlay-outer">
        <div id="transition-overlay" :class="(didOnce) ? 'did-once' : ''">

        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import gsap, {  Power3, Linear } from 'gsap'
    import gh from '@/helpers/gh'
    //import { SplitText} from 'gsap/SplitText'
    //gsap.registerPlugin(SplitText)
    export default {
        name: "TransitionOverlay",
        components: {

        },
        data() {
            return {
                window:window,
                show:true, //start showing
                tme:0.25,
                didOnce:false,
            }
        },
        computed: {
            ...mapState({
                triggerTransitionOverlay: state => state.triggerTransitionOverlay,
                routerNext: state => state.routerNext,
            }),
        },
        watch: {
            triggerTransitionOverlay() {
                if (this.triggerTransitionOverlay) {
                    //let doSkip = false //debugging
                    if (!this.didOnce || this.window.config.skipPreview) {
                        //local first page build skip transition
                        this.routerNext()
                        this.reveal4()
                    } else {
                        //normal reveal for all
                        this.reveal()
                    }

                }
            }
        },
        methods: {
            isHomePage() {
                return this.$route.path === '/';
            },
            reveal() {
                if (this.isHomePage() && this.didOnce  === false) {
                    this.show = false
                    this.routerNext()
                    if (this.didOnce === false) {
                        setTimeout(this.reveal3,0   )
                    }
                    return;
                }

                this.show = true
                let tl = gsap.timeline({});
                let nextTime = 500
                if (this.didOnce) {
                    tl.fromTo('#transition-overlay', 0.25,
                        { opacity:0 },
                        { opacity:1, ease: Power3.easeInOut },
                        0
                    )
                } else {
                    //first time
                    this.routerNext()
                    tl.fromTo('#transition-overlay', 0,
                        { opacity:1 },
                        { opacity:1, ease: Power3.easeInOut },
                        0
                    )
                }

                setTimeout(this.reveal2,nextTime   )
            },
            reveal2() {
                if (this.didOnce) {
                    this.routerNext()
                }
                setTimeout(this.reveal3,250   )
            },
            reveal3() {
                let tl = gsap.timeline({});

                tl.fromTo('#transition-overlay', this.tme,
                    { opacity: 1 },
                    { opacity: 0, ease: Linear.easeNone,onComplete:this.reveal4 },
                    0
                )
                this.firstHeaderAnimation(0.25)
            },
            firstHeaderAnimation(del=0) {
                //FIRST HEADER ANIMATION
                if (this.didOnce === false) {
                    // new SplitText('#header-container', {
                    //     type: 'words, chars',
                    //     charsClass: 'txt-split'
                    // })
                    let tl = gsap.timeline({
                        delay:del
                    });
                    tl.to("#header-container",
                        {
                            duration: 1,
                            ease: Linear.easeNone,
                            opacity:1,
                        },
                        0
                    )
                }

                // trigger this earlier for home animation
                this.$store.commit('setDidInitialSiteTransition')

                //final - needs to be double set because sometimes this is called out of order
                this.didOnce = true


            },
            reveal4() {
                this.show = false

                this.window.config.routerInTransition = false
                if (!this.didOnce) {
                    this.$store.commit('setDidInitialSiteTransition')
                }

                gh.globalSectionInit()

                this.firstHeaderAnimation()

                //final
                this.didOnce = true
            }
        }
    }
</script>
